'use strict';

import fd, {mutate} from './lib/promise-fastdom';
import ToggleArea from './lib/ToggleArea';
import nodeFromTemplate from './lib/node-from-template';
import ButtonBehavior from './lib/ToggleArea_ButtonBehavior';
import BreakpointObserver from './lib/BreakpointObserver';
import initHandlers from './nav-events';

export default function init() {
    return fd.mutate(function () {

        let nav;
        let ready = Promise.resolve();

        const root = document.documentElement;
        const button = nodeFromTemplate('nav-toggle-tpl');
        const area = document.getElementById(button.getAttribute('aria-controls'));
        const network = area.querySelector('.nav__network');

        initHandlers(nav, area, button);

        // mode change
        (new BreakpointObserver('desktop')).observe(query => {
            ready = Promise.resolve(ready)
                .then((reset) => typeof reset === 'function' ? reset() : null)
                .then(() => query.matches ? initDesktopMode() : initMobileMode());
        });

        function initDesktopMode() {
            return Promise.resolve()
                .then(mutate(function () {
                    root.classList.remove('nav-on')
                    network.parentNode.insertAdjacentElement('afterbegin', network);
                }))
                .then(function () {
                    return function reset() {
                        return fd.mutate(() => {
                            network.parentNode.insertAdjacentElement('beforeend', network);
                        });
                    };
                });
        }

        function initMobileMode() {
            return Promise.resolve()
                .then(mutate(function () {
                    document.querySelector('.header__inner').insertAdjacentElement('beforeend', button);
                    nav = new ToggleArea(area, 'nav', [
                        new ButtonBehavior(button)
                    ]);

                    return nav.ready();
                }))
                .then(function () {
                    return function reset() {
                        return nav.destroy().then(function () {
                            button.remove();
                            nav = null;
                        });
                    };
                });
        }
    });
}